import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import Select from "react-select";
import { toast } from "react-toastify";
import { Link } from "react-router";
import Pagination from "../../shared/common/pagination";
import Loader from "../../shared/loader/loader";
import DeleteModal from "../../shared/common/deleteModal";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Constant from "../../../utils/constant";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import { connect } from "react-redux";
import AddBundle from "../../shared/common/addBundle";
import {
  AddIcon,
  FilterIcon,
  EditIcon,
  DeleteIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  CSVIcon,
  BundleIcon,
  CollapseDownIcon,
  CollapseUpIcon,
  ApproveIcon,
  Disapprove,
} from "../../../assets/icons/index";
import {
  getGradeAll,
  getStateAll,
  getSubject,
} from "../../../api/subject.service";
import {
  getSellableProductAll,
  getSubjectsSellableProduct,
  deleteSellableProduct,
  deleteSellableProductSubject,
} from "../../../api/pricing.services";
import { ISellableProductFilters } from "../../../model/interface/sellableProduct";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import ExportToCSV from "../../shared/common/exportToCsv";
import ActiveRowLine from "../../shared/common/activeRowLine";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";
import Bundle from "../bundle/bundle";

const activeMultiState = [
  { label: "Active", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Inactive", value: false },
];
const CANNED_TEST_PRODUCT_TYPE_ID = 3;

const SellableProducts: React.FC<any> = (props: any) => {
  const sellableProductTypeNames: Record<number, string> = {
    1: "Subjects",
    2: "Lesson Plans",
    3: "Canned Tests",
    4: "Item Bank",
  };
  const initialState: ISellableProductFilters = {
    sellableProductId: 0,
    sellableProductName: "",
    subjectId: 0,
    subjectName: "",
    contentAreaId: 0,
    contentAreaName: "",
    stateId: 0,
    stateName: "",
    gradeId: 0,
    gradeName: "",
    gradeLevelId: "",
    gradeLevelName: "",
    isActive: undefined,
    isApproved: true,
    sellableProductTypeId: 0,
  };
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);
  const [totalPages, setTotalPages] = useState<number>(defaultPageNumber);
  const [sellableproduct, setSellableproduct] = useState<any>([]);
  const [grade, setGrade] = useState<any>([]);
  const [state, setState] = useState<any>([]);
  const [content, setContent] = useState<any>([]);
  const [subjects, setSubjects] = useState<any>([]);
  const [sellableproductSubjects, setSellableproductSubjects] = useState<any>(
    []
  );
  const [DeleteSellableProduct, setDeleteSellableProduct] = useState<number>(0);
  const [DeleteSellableProductSubject, setDeleteSellableProductSubject] =
    useState<number>(0);
  const [toggle, setToggle] = useState<number>();
  const navigate = useNavigate();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [filterInput, setFilterInput] =
    useState<ISellableProductFilters>(initialState);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [sortDir, setSortDir] = useState<any>(false);
  const [sortCol, setSortCol] = useState<string>("name");
  const childRef: any = useRef(undefined);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [selectedSubjectId, setSelectedSubjectId] = useState<number>();
  const [selectedProductId, setSelectedProductId] = useState<number>();
  const [selectedProductName, setSelectedProductName] = useState<string>("");
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const productTypes: ISelectElement[] = [
    { value: "1", label: "Subjects" },
    { value: "2", label: "Lesson Plans" },
    { value: "3", label: "Canned Tests" },
    { value: "4", label: "Item Bank" },
  ];
  const [selectedProductType, setSelectedProductType] =
    useState<ISelectElement | null>(null);
  const [appliedProductTypeId, setAppliedProductTypeId] = useState<number>(0);

  const handleRedirect = (product) => {
    navigate(
      Constant.MANAGESELLABLEPRODUCT.replace(
        ":id",
        product.sellableProductId.toString()
      )
    );
  };

  const posthandleRedirect = () => {
    navigate(Constant.ADDSELLABLEPRODUCT);
  };

  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setState(newStateData);
    setLoading(false);
  };

  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrade(newGradeData);
  };

  const getContent = async () => {
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(999, 1);
    const data = (await response).data;
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContent(newContentData);
  };

  const getSubjectData = async () => {
    console.log("getSubjectData");
    setLoading(true);

    const params = {
      name: "",
      contentAreaId: filterInput.contentAreaId || 0,
      stateId: filterInput.stateId || 0,
      gradeId: filterInput.gradeId || 0,
      gradeLevel: filterInput.gradeLevelId || "",
      orderbyColumn: "name",
      sortDir: "asc",
      pageSize: 999,
      pageNumber: 1,
      isActive: true,
      isApproved: true,
    };

    const response = getSubject(params);
    const data = (await response).data;
    setLoading(false);

    let newSubjectData = [];
    if (data.data.length > 0) {
      newSubjectData = data.data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setSubjects(newSubjectData);
  };

  const getSellableProducts = async () => {
    setLoading(true);
    const response = getSellableProductAll({
      sellableProductId: filterInput.sellableProductId,
      name: filterInput.sellableProductName,
      subjectId: filterInput.subjectId,
      contentAreaId: filterInput.contentAreaId,
      stateId: filterInput.stateId,
      gradeId: filterInput.gradeId,
      gradeLevelId: filterInput.gradeLevelId,
      isActive: isActive,
      isApproved: filterInput.isApproved,
      orderByColumn: sortCol ? sortCol : "name",
      sortDir: sortDir ? "asc" : "desc",
      pageSize: pageSize,
      pageNumber: pageNumber,
      sellableProductTypeId: filterInput.sellableProductTypeId || 0,
    });

    const data = (await response).data;
    setSellableproduct(data.data);
    setAppliedProductTypeId(filterInput.sellableProductTypeId || 0);
    setTotalPages(Math.ceil(data.totalRecords / pageSize));
    setTotalRecords(data.totalRecords);
    setLoading(false);
  };

  const getSellableProductsSubjects = async (id, index, type?) => {
    setLoading(true);
    if (type === "show") {
      const response = getSubjectsSellableProduct(id);
      const data = (await response).data;

      setSellableproductSubjects(data);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isLoaded) {
      getSellableProducts();
    }
    setToggle(undefined);
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      getSellableProducts();
      getSubjectData();
      getGradeData();
      getStateData();
      getContent();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
    setToggle(undefined);
  }, [pageSize]);

  useEffect(() => {
    if (isLoaded) {
      filterSellableProducts();
    }
  }, [sortDir]);

  const deleteRecordHandler = async () => {
    if (DeleteSellableProductSubject > 0) {
      deleteSellableProductSubject(
        DeleteSellableProductSubject,
        DeleteSellableProduct
      ).then((res) => {
        toast.success("Deleted successfully");
      });
    } else if (DeleteSellableProductSubject === 0) {
      deleteSellableProduct(DeleteSellableProduct, props.profile?.userId).then(
        (res) => {
          toast.success("Deleted successfully");
        }
      );
    }

    getSellableProducts();
    getSellableProductsSubjects(DeleteSellableProduct, 0);
    setShowDeleteModal(false);
  };

  const deleteRecord = (id, subjectId) => {
    setShowDeleteModal(true);
    setDeleteSellableProduct(id);
    setDeleteSellableProductSubject(subjectId);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const filterInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setFilterInput({
      ...filterInput,
      [name]: value,
    });

    if (e.target.value === "") {
      filterSellableProducts({
        name: "",
        sellableProductId: 0,
        subjectId: 0,
        contentAreaId: 0,
        stateId: 0,
        gradeId: 0,
        gradeLevelId: "",
        isActive: isActive,
        isApproved: true,
        orderByColumn: "name",
        sortDir: "asc",
        pageNumber: 1,
        pageSize: 10,
      });
    }
  };

  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "subject") {
      setFilterInput({
        ...filterInput,
        subjectId: updateObj.value || 0,
        subjectName: updateObj.label || 0,
      });
    } else if (updateObj.type == "contentArea") {
      setFilterInput({
        ...filterInput,
        contentAreaId: updateObj.value || 0,
        contentAreaName: updateObj.label || "",
      });
    } else if (updateObj.type == "state") {
      setFilterInput({
        ...filterInput,
        stateId: updateObj.value || 0,
        stateName: updateObj.label || 0,
      });
    } else if (updateObj.type == "grade") {
      setFilterInput({
        ...filterInput,
        gradeId: updateObj.value || 0,
        gradeName: updateObj.label || 0,
      });
    } else if (updateObj.type == "gradeLevel") {
      setFilterInput({
        ...filterInput,
        gradeLevelId: updateObj.value || "",
        gradeLevelName: updateObj.label || "",
      });
    }
  };

  const filterHandler = async (e) => {
    if (e) e.preventDefault();
    filterSellableProducts(false, true);
  };

  const filterSellableProducts = async (resetObj?, onFilter?, column?) => {
    if (resetObj || onFilter) pageSizeRef?.current?.onReset();
    setLoading(true);
    const filterObj = {
      sellableProductId: filterInput.sellableProductId,
      name: filterInput.sellableProductName,
      subjectId: filterInput.subjectId,
      contentAreaId: filterInput.contentAreaId,
      stateId: filterInput.stateId,
      gradeId: filterInput.gradeId,
      gradeLevelId: filterInput.gradeLevelId,
      isActive: isActive,
      isApproved: filterInput.isApproved,
      sellableProductTypeId: filterInput.sellableProductTypeId || 0,
      orderByColumn: sortCol,
      sortDir: sortDir ? "asc" : "desc",
      pageSize: onFilter ? defaultPageSize : pageSize,
      pageNumber: onFilter ? defaultPageNumber : pageNumber,
    };
    if (resetObj) setIsActive(undefined);
    const response = getSellableProductAll(resetObj ? resetObj : filterObj);
    const data = (await response).data;

    setSellableproduct(data.data);
    setAppliedProductTypeId(
      resetObj ? 0 : filterInput.sellableProductTypeId || 0
    );
    setTotalPages(
      Math.ceil(data.totalRecords / (resetObj ? defaultPageSize : pageSize))
    );
    setTotalRecords(data.totalRecords);
    setLoading(false);
  };

  const resetClickHandler = () => {
    setIsActive(undefined);
    setResetDropdownFlag(!resetDropdownFlag);
    setSelectedProductType(null);
    setFilterInput({
      ...initialState,
    });

    filterSellableProducts({
      name: "",
      sellableProductId: 0,
      subjectId: 0,
      contentAreaId: 0,
      stateId: 0,
      gradeId: 0,
      gradeLevelId: "",
      isActive: undefined,
      isApproved: true,
      orderByColumn: "name",
      sortDir: "desc",
      pageNumber: 1,
      pageSize: 10,
    });

    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  const handleSortBy = (column: string) => {
    setSortDir(!sortDir);
    setSortCol(column);
  };

  useEffect(() => {
    getSubjectData();
  }, [
    filterInput.contentAreaId,
    filterInput.stateId,
    filterInput.gradeId,
    filterInput.gradeLevelId,
  ]);

  const exportFn = async () => {
    setLoading(true);
    const filterObj = {
      sellableProductId: filterInput.sellableProductId,
      name: filterInput.sellableProductName,
      subjectId: filterInput.subjectId,
      contentAreaId: filterInput.contentAreaId,
      stateId: filterInput.stateId,
      gradeId: filterInput.gradeId,
      gradeLevelId: filterInput.gradeLevelId,
      isActive: isActive,
      isApproved: filterInput.isApproved,
      orderByColumn: sortCol,
      sortDir: sortDir ? "asc" : "desc",
      pageSize: 9999,
      pageNumber: 1,
    };

    const response = getSellableProductAll(filterObj);
    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "sellableProducts.csv");
    } else {
      toast.warning("No records to download");
    }
  };
  function handleAddBundleConfimation(confirmAction: boolean) {
    setShowConfirmation(false);
    resetClickHandler();
  }
  function handleAddBundle(productName: string, productId: number) {
    setSelectedProductId(productId);
    setSelectedProductName(productName);

    setShowConfirmation(true);
  }

  function redirectToBundleDetail(bundleId: number) {
    if (bundleId) {
      navigate(Constant.EDITBUNDLES.replace(":id", bundleId.toString()));
    }
  }

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("sellableProductId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  function handleRedirection(name: string, id: number) {
    if (name === "subject" && id) {
      navigate(Constant.SUBJECTDETAIL.replace(":id", id.toString()), {
        state: { subjectType: 1 },
      });
    } else if (name === "content" && id) {
      navigate(Constant.EDITCONTENT.replace(":id", id.toString()));
    } else if (name && id) {
      navigate(`/${name}/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }

  return (
    <AllowedTo
      perform={Permissions.sellable_product_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showConfirmation && (
        <AddBundle
          productId={selectedProductId}
          productName={selectedProductName}
          title={"Add Sellable Product to bundle"}
          confirmAction={handleAddBundleConfimation}
          message={"Please Select Bundle"}
          buttonText={"Add"}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                Sellable Product
              </h3>

              <AllowedTo perform={Permissions.sellable_product_create}>
                <button
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                  onClick={() => posthandleRedirect()}
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add Sellable Product
                </button>
              </AllowedTo>
            </div>
            <form onSubmit={filterHandler}>
              <div className="pt-6 border-b pb-6">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-2 sm:col-span-2 ">
                    <label className="text-sm text-gray-700">
                      Sellable Product Id
                    </label>
                    <div className="contentArea">
                      <input
                        id="sellableProductId"
                        name="sellableProductId"
                        type="text"
                        autoComplete="off"
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        value={filterInput.sellableProductId || ""}
                        onChange={filterInputChangeHandler}
                      />
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-2 ">
                    <label className="text-sm text-gray-700">
                      Sellable Product Name
                    </label>
                    <div className="contentArea">
                      <input
                        id="sellableProductName"
                        name="sellableProductName"
                        type="text"
                        autoComplete="off"
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        value={filterInput.sellableProductName}
                        onChange={filterInputChangeHandler}
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Content Area
                    </label>
                    <div className="mt-1">
                      <Select
                        options={content}
                        value={{
                          label: filterInput.contentAreaName,
                          value: filterInput.contentAreaId,
                        }}
                        placeholder={""}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={(e) =>
                          updateDropdownValues({ ...e, type: "contentArea" })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">State</label>
                    <div className="mt-1">
                      <Select
                        options={state}
                        value={{
                          label: filterInput.stateName,
                          value: filterInput.stateId,
                        }}
                        placeholder={""}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={(e) =>
                          updateDropdownValues({ ...e, type: "state" })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade</label>
                    <div className="mt-1">
                      <Select
                        options={grade}
                        value={{
                          label: filterInput.gradeName,
                          value: filterInput.gradeId,
                        }}
                        placeholder={""}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={(e) =>
                          updateDropdownValues({ ...e, type: "grade" })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade Level</label>
                    <div className="mt-1">
                      <Select
                        options={gradeLevelData}
                        value={{
                          label: filterInput.gradeLevelName,
                          value: filterInput.gradeLevelId,
                        }}
                        placeholder={""}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={(e) =>
                          updateDropdownValues({ ...e, type: "gradeLevel" })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Subject</label>
                    <div className="mt-1">
                      <Select
                        options={subjects}
                        value={{
                          label: filterInput.subjectName,
                          value: filterInput.subjectId,
                        }}
                        placeholder={""}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={(e) =>
                          updateDropdownValues({ ...e, type: "subject" })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Sellable Product Type
                    </label>
                    <div className="mt-1">
                      <Select
                        inputId="sellableProductTypeFilter"
                        options={productTypes}
                        value={selectedProductType}
                        isClearable
                        placeholder=""
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        onChange={(e) => {
                          setSelectedProductType(e as ISelectElement | null);
                          setFilterInput((prev) => ({
                            ...prev,
                            sellableProductTypeId: e
                              ? parseInt((e as ISelectElement).value)
                              : 0,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-span-2 flex items-center mt-6">
                    <MultiStateButton
                      labels={activeMultiState}
                      onSelect={(e) => setIsActive(e.value)}
                      onReset={resetDropdownFlag}
                    />
                  </div>
                  <div className="col-span-1 sm:col-span-1 flex items-end items-center mt-6">
                    <div className="flex items-center ">
                      <input
                        id="isApproved"
                        name="isApproved"
                        type="checkbox"
                        checked={filterInput.isApproved}
                        onChange={filterInputChangeHandler}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                      <label className="ml-1.5 text-sm text-gray-700">
                        Approved
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex justify-start">
                  <button
                    type="submit"
                    className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    onClick={resetClickHandler}
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>
              <div className="flex justify-end mb-2">
                <button
                  type="button"
                  onClick={() => exportFn()}
                  className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                  <span>Export</span>
                </button>
                <ExportToCSV ref={childRef} />
              </div>
            </form>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full table-fixed divide-y divide-gray-200">
                        <colgroup>
                          <col className="w-[10%]" />
                          <col className="w-[26%]" />
                          <col className="w-[20%]" />
                          <col className="w-[16%]" />
                          <col className="w-[16%]" />
                          <col className="w-[12%]" />
                        </colgroup>
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="inline-flex items-center gap-2 px-6 py-2 pl-8 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Id
                                <span className="cursor-pointer">
                                  {sortDir &&
                                  sortCol === "sellableProductId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("sellableProductId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("sellableProductId")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Name
                                <span className="cursor-pointer">
                                  {sortDir && sortCol === "name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Bundles</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light break-words text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                {appliedProductTypeId ===
                                CANNED_TEST_PRODUCT_TYPE_ID
                                  ? "Canned Test Count"
                                  : "Subjects Count"}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Type</span>
                            </th>
                            <th
                              scope="col"
                              className="w-10 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {sellableproduct.map((product, index) => (
                            <Disclosure key={index}>
                              {({ open }) => (
                                <>
                                  <tr
                                    key={index}
                                    className={`align-top  ${
                                      index % 2 === 0
                                        ? "bg-white "
                                        : "bg-gray-100"
                                    }`}
                                  >
                                    <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                      <ActiveRowLine
                                        isActive={product.isActive}
                                      />
                                      <div className="flex ...">
                                        <div className="mt-2">
                                          {product?.totalSubjectCount ? (
                                            <DisclosureButton className="">
                                              {index !== toggle && (
                                                <CollapseDownIcon
                                                  key={index}
                                                  className={`${""} w-5 h-5`}
                                                  onClick={(e) => {
                                                    getSellableProductsSubjects(
                                                      product.sellableProductId,
                                                      index,
                                                      "show"
                                                    );
                                                  }}
                                                />
                                              )}
                                              {index === toggle && (
                                                <CollapseUpIcon
                                                  key={index}
                                                  className={`${
                                                    !open ? "" : ""
                                                  } w-5 h-5`}
                                                  onClick={(e) => {
                                                    getSellableProductsSubjects(
                                                      product.sellableProductId,
                                                      index,
                                                      "hide"
                                                    );
                                                  }}
                                                />
                                              )}
                                            </DisclosureButton>
                                          ) : (
                                            <DisclosureButton className="invisible">
                                              {index !== toggle && (
                                                <CollapseDownIcon
                                                  key={index}
                                                  className={`${""} w-5 h-5 cursor-not-allowed`}
                                                />
                                              )}
                                              {index === toggle && (
                                                <CollapseUpIcon
                                                  key={index}
                                                  className={`${
                                                    !open ? "" : ""
                                                  } w-5 h-5 cursor-not-allowed`}
                                                />
                                              )}
                                            </DisclosureButton>
                                          )}
                                        </div>

                                        <div className="mt-2 ml-2">
                                          <Link
                                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                            to={Constant.MANAGESELLABLEPRODUCT.replace(
                                              ":id",
                                              product.sellableProductId.toString()
                                            )}
                                          >
                                            {product.sellableProductId}
                                          </Link>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="px-3 py-2  pl-6 break-words text-sm text-left font-normal text-gray-500">
                                      <Link
                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                        to={Constant.MANAGESELLABLEPRODUCT.replace(
                                          ":id",
                                          product.sellableProductId.toString()
                                        )}
                                      >
                                        {product.name}
                                      </Link>
                                    </td>
                                    <td className="px-3 py-2  pl-3 break-words text-sm text-left font-normal text-gray-500">
                                      {product?.bundles?.map((bundle) => (
                                        <div className="grid" key={bundle.id}>
                                          <Link
                                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                            to={Constant.EDITBUNDLES.replace(
                                              ":id",
                                              bundle.id.toString()
                                            )}
                                          >
                                            {bundle.name}
                                          </Link>
                                        </div>
                                      ))}
                                    </td>
                                    <td className="px-3 py-2  pl-3 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                      {product.totalSubjectCount}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-500">
                                      {sellableProductTypeNames[
                                        product.sellableProductTypeId
                                      ] ?? "—"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                      <div className="flex gap-3 justify-center">
                                        <AllowedTo
                                          perform={
                                            Permissions.sellable_product_modify
                                          }
                                        >
                                          <span
                                            className="relative cursor-pointer "
                                            onClick={() => {
                                              handleAddBundle(
                                                product.name,
                                                product.sellableProductId
                                              );
                                            }}
                                          >
                                            <BundleIcon className="w-4 hover:text-secondary-color fill-current text-gray-500" />
                                            <span className="text-xl text-gray-700 absolute top-0 -right-1">
                                              +
                                            </span>
                                          </span>
                                        </AllowedTo>

                                        <AllowedTo
                                          perform={
                                            Permissions.sellable_product_modify
                                          }
                                        >
                                          <EditIcon
                                            onClick={(e) =>
                                              handleRedirect(product)
                                            }
                                            className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                          />
                                        </AllowedTo>

                                        <AllowedTo
                                          perform={
                                            Permissions.sellable_product_delete
                                          }
                                        >
                                          <DeleteIcon
                                            onClick={(e) =>
                                              deleteRecord(
                                                product.sellableProductId,
                                                0
                                              )
                                            }
                                            className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                          />
                                        </AllowedTo>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={6} className="relative ">
                                      <div
                                        className={`${
                                          index !== toggle ? "hidden" : ""
                                        } pl-12 pr-12 px-4 pb-2 text-sm text-gray-500`}
                                      >
                                        <ActiveRowLine
                                          isActive={product.isActive}
                                        />
                                        <div className="shadow border-b rounded-lg">
                                          <table className="min-w-full">
                                            <thead>
                                              <tr className="bg-gray-50 border">
                                                <th
                                                  scope="col"
                                                  className="inline-flex items-center gap-2 px-3 py-2 pl-6 font-semibold text-gray-500 text-xs text-left tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Id
                                                  </span>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 font-semibold text-xs text-left text-gray-500 tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Subject Name
                                                  </span>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 font-semibold text-xs text-left text-gray-500 tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Content Area Name
                                                  </span>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 font-semibold text-xs text-left text-gray-500 tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Approved
                                                  </span>
                                                </th>

                                                <th
                                                  scope="col"
                                                  className="w-10 px-3 py-2 font-semibold text-xs text-center text-gray-500 tracking-wider"
                                                >
                                                  Action
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-50">
                                              {sellableproductSubjects.map(
                                                (subject, index) => (
                                                  <tr key={index}>
                                                    <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                      <Link
                                                        to={Constant.SUBJECTDETAIL.replace(
                                                          ":id",
                                                          subject.subjectId
                                                            ? subject.subjectId.toString()
                                                            : ""
                                                        )}
                                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                                      >
                                                        {subject.subjectId}
                                                      </Link>
                                                    </td>
                                                    <td
                                                      className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 cursor-pointer text-indigo-600 hover:text-indigo-500"
                                                      onClick={() =>
                                                        handleRedirection(
                                                          "subject",
                                                          parseInt(
                                                            subject.subjectId
                                                          )
                                                        )
                                                      }
                                                    >
                                                      <Link
                                                        to={Constant.SUBJECTDETAIL.replace(
                                                          ":id",
                                                          subject.subjectId
                                                            ? subject.subjectId.toString()
                                                            : ""
                                                        )}
                                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                                      >
                                                        {subject.name}
                                                      </Link>
                                                    </td>
                                                    <td
                                                      className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 cursor-pointer text-indigo-600 hover:text-indigo-500"
                                                      onClick={() =>
                                                        handleRedirection(
                                                          "content",
                                                          parseInt(
                                                            subject.contentAreaId
                                                          )
                                                        )
                                                      }
                                                    >
                                                      <Link
                                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                                        to={Constant.EDITCONTENT.replace(
                                                          ":id",
                                                          subject.contentAreaId.toString()
                                                        )}
                                                      >
                                                        {
                                                          subject.contentAreaName
                                                        }
                                                      </Link>
                                                    </td>
                                                    <td className="px-3 py-2 pl-12 text-sm text-center font-normal text-gray-500">
                                                      {subject.isApproved ? (
                                                        <ApproveIcon />
                                                      ) : (
                                                        <Disapprove />
                                                      )}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                                      <div className="flex gap-3 justify-center">
                                                        <DeleteIcon
                                                          onClick={(e) =>
                                                            deleteRecord(
                                                              product.sellableProductId,
                                                              subject.subjectId
                                                            )
                                                          }
                                                          className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                                        />
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                        {sellableproductSubjects.length ===
                                          0 && (
                                          <p className="p-2">
                                            No Subject Added
                                          </p>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </Disclosure>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    sellableproduct.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span className="">
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                    />
                  </span>
                </div>
                {sellableproduct.length === 0 && (
                  <p className="p-2">No Records Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(SellableProducts);
